module.exports = __webpack_public_path__ + "img/Löwenzahnohr.212cab9b.jpg";